import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { AuthenticationService } from '../_services/authentication.service';
import { DashboardService } from '../_services/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  data: any[];
  subscriptions: Subscription[] = [];

  constructor(
    private dashboardService: DashboardService,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  /* ====================================
   *              LIFECYCLES
   ======================================= */
  ngOnInit(): void {
    this.getData();

    setInterval(() => {
      this.getData();
    }, 120000);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
   *             MAIN FEATURES
   ======================================= */
  getData() {
    this.loading = true;
    this.subscriptions.push(
      this.dashboardService.getAll().subscribe({
        next: (responseData: any) => {
          this.data = responseData.map((worker) => {
            return {
              ...worker,
              currentOperation:
                worker.currentOperation === 'zz'
                  ? ' '
                  : worker.currentOperation,
            };
          });

          this.loading = false;
        },
        error: (err) => {
          if (err.status === 401) {
            this.authService.logout().subscribe(() => {
              this.router.navigate(['/login']);
            });
          }
        },
      })
    );
  }
}
